import * as actions from '../actions/types'

const initialState = {
  lifeCircumstances: true,
  foreignLanguage: {
    asl: false,
    arabic: false,
    chinese: false,
    farsi: false,
    russian: false,
    spanish: false,
    tagalog: false,
    other: false
  },
  teas: {
    passed: false
  }
};

function updateOtherInfo(otherState, action){
  return {
    ...otherState,
    ...action.updates
  };
}

function setOtherInfo(otherState, action){
  return {
    ...otherState,
    ...action.application.other
  };
}

function toggleLifeCircumstances(otherState){
  return {
    ...otherState,
    lifeCircumstances: !otherState.lifeCircumstances
  }
}

function updateTeas(otherState, action){
  return {
    ...otherState,
    teas: {
      ...otherState.teas,
      ...action.updates
    }
  }
}

function applicationDeleted() {
  return initialState;
}

export const otherInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_OTHER_INFO: return updateOtherInfo(state, action);
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setOtherInfo(state, action);
    case actions.TOGGLE_LIFE_CIRCUMSTANCES: return toggleLifeCircumstances(state, action);
    case actions.UPDATE_TEAS: return updateTeas(state, action);
    case actions.DELETE_APPLICATION_SUCCESS: return applicationDeleted(state, action);
    default: return state;
  }
};

export default otherInfoReducer;